/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterT = createReactComponent("letter-t", "IconLetterT", [
  ["path", { d: "M6 4l12 0", key: "svg-0" }],
  ["path", { d: "M12 4l0 16", key: "svg-1" }]
]);

export { IconLetterT as default };
//# sourceMappingURL=IconLetterT.js.map
